import { call, put, takeEvery, select } from 'redux-saga/effects';
import { defineKqlQuery, searchSubmissions } from '@kineticdata/react';
import { C } from '@kineticdata/bundle-common';
import { actions, types } from '../modules/service';
import { List } from 'immutable';

/**
 * Fetches the latest active record for the selected service.
 */
export function* fetchServiceSaga({ payload }) {
  const authenticated = yield select(state => state.app.authenticated);
  const profile = yield select(state => state.app.profile);

  const query = defineKqlQuery()
    .equals(`values[${C.FIELD_STATUS}]`, 'status')
    .equals(`values[${C.FIELD_SERVICE_ID}]`, 'id');
  if (!profile || !profile.hasInternalCatalogAccess) {
    query.equals(`values[Type]`, 'public');
  }

  const { submissions, error } = yield call(searchSubmissions, {
    kapp: C.KAPP_SLUG_DATASTORE,
    form: C.FORM_SLUG_SERVICE,
    limit: 1000,
    search: {
      q: query.end()({
        status: 'Active',
        id: payload,
        public: 'Public',
      }),
      include: ['details', 'values', 'form'],
    },
    public: !authenticated,
  });

  if (error) {
    yield put(actions.fetchServiceFailure({ id: payload, error }));
  } else {
    // Sort returned services by most recently updated and take the first one
    const currentService = List(submissions)
      .sortBy(s => s.updatedAt)
      .reverse()
      .first();

    if (!!currentService) {
      yield put(
        actions.fetchServiceSuccess({
          id: payload,
          data: currentService,
        }),
      );
    } else {
      yield put(
        actions.fetchServiceFailure({
          id: payload,
          error: {
            statusCode: 404,
            message: `Unable to locate the ${payload} service`,
          },
        }),
      );
    }
  }
}

export function* watchService() {
  yield takeEvery(types.FETCH_SERVICE_REQUEST, fetchServiceSaga);
}
